import { render, staticRenderFns } from "./Logo.vue?vue&type=template&id=258cdb52&scoped=true&"
import script from "./Logo.ts?vue&type=script&lang=ts&"
export * from "./Logo.ts?vue&type=script&lang=ts&"
import style0 from "./Logo.css?vue&type=style&index=0&id=258cdb52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "258cdb52",
  null
  
)

export default component.exports